import "@nectary/components/toast-manager";
import "@nectary/components/toast";
import "@nectary/components/icon-button";
import type { TSinchToastManagerOrigin } from "@nectary/components/toast-manager/types";
import type { ToastClosedMethod } from "@sinch/bus";
import { type FC } from "react";
import { NectaryIcon } from "../Icon";
import {
  useToastHandler,
  type Toast,
  useToastClearedCallback,
} from "./useToastHandler";

type ToastProps = Toast & {
  onClose: (method: ToastClosedMethod) => void;
};

const Toast = ({
  id,
  type,
  text,
  persistent,
  closable,
  onClose,
}: ToastProps) => {
  useToastClearedCallback(id, onClose);

  return (
    <sinch-toast
      key={id}
      type={type}
      text={text}
      persistent={persistent}
      on-timeout={() => onClose("timeout")}
    >
      {closable && (
        <sinch-icon-button
          slot="close"
          aria-label="Close"
          size="s"
          on-click={() => onClose("click")}
        >
          <NectaryIcon name="close" slot="icon" />
        </sinch-icon-button>
      )}
    </sinch-toast>
  );
};

export const ToastManager: FC<{
  origin?: TSinchToastManagerOrigin;
}> = ({ origin = "bottom-right" }) => {
  const { toasts, onClose } = useToastHandler();

  return (
    <sinch-toast-manager
      style={{ position: "relative", zIndex: 999999 }}
      origin={origin}
    >
      {toasts.map(({ id, text, type, closable, persistent }) => (
        <Toast
          key={id}
          id={id}
          text={text}
          type={type}
          closable={closable}
          persistent={persistent}
          onClose={onClose(id)}
        />
      ))}
    </sinch-toast-manager>
  );
};
